// extracted by mini-css-extract-plugin
export var md = "_46-4";
export var semantic = "_46-5";
export var sm = "_46-3";
export var text = "_46-6";
export var toggleInput = "_46-0";
export var toggleSwitch = "_46-1";
export var xs = "_46-2";